import React from "react";
import { observer, inject } from "mobx-react";
import { Button } from "@material-ui/core";
import Menu from "../../common/components/input/Menu/Menu";
import { MdVisibilityOff } from "react-icons/md";
import COLORS from "scss/colors.module.scss";
import HideFieldsStore from "./HideFieldsStore";
import styled, { css } from "styled-components";
import { StyledTooltip } from "app/common/utils/StyledTooltip";
import StyledToolbarButton, {
  StyledToolbarTitle,
} from "app/list/ToolBar/StyledToolbarButton";

class HideFields extends React.Component {
  constructor(props) {
    super(props);
    this.store = new HideFieldsStore(props);
    this.state = {
      isButtonTextOverFlown: false,
    };
    this.buttonTextRef = React.createRef();
  }

  updateButtonTextOverFlowStatus() {
    if (this.buttonTextRef && this.buttonTextRef.current) {
      setTimeout(() => {
        let isTextOverFlown =
          this.buttonTextRef?.current?.scrollWidth >
          this.buttonTextRef?.current?.clientWidth;
        if (
          typeof isTextOverFlown !== "undefined" &&
          isTextOverFlown !== this.state.isButtonTextOverFlown
        ) {
          this.setState({ isButtonTextOverFlown: isTextOverFlown });
        }
      }, 1);
    }
  }

  componentDidUpdate() {
    this.updateButtonTextOverFlowStatus();
  }

  render() {
    let me = this,
      store = this.store;
    const buttonText =
      this.store.getHiddenFieldsCount() === 0
        ? "Hide fields"
        : this.store.getHiddenFieldsCount() +
          " hidden field" +
          (this.store.getHiddenFieldsCount() > 1 ? "s" : "");

    return (
      <>
        <StyledTooltip
          title={buttonText}
          // disableHoverListener={
          //   window.screen.width <= 1401
          //     ? !this.state.isButtonTextOverFlown
          //     : true
          // }
          disableHoverListener={!this.state.isButtonTextOverFlown}
        >
          <StyledToolbarButton
            className="d-flex"
            highlighted={this.store.getHiddenFieldsCount()}
            screenWidth={window.screen.width}
            onClick={store.setAnchorEl}
            isMaxWidth={true}
          >
            <MdVisibilityOff size={18} color={COLORS.TEXT_COLOR} />
            <StyledToolbarTitle
              ref={this.buttonTextRef}
              screenWidth={window.screen.width}
              isMaxWidth={true}
            >
              {buttonText}
            </StyledToolbarTitle>

          </StyledToolbarButton>
        </StyledTooltip>
        <Menu
          open={Boolean(store.anchorEl)}
          menuItems={store.getAllColumns()}
          anchorElement={store.anchorEl}
          onClose={store.handleClose}
          valueKey={"alias_path"}
          isCheckBox={true}
          loadingMenuItems={this.props.viewStore.loadingColumns}
          checkedValues={store.checkedValues}
          onMenuItemClick={store.handleMenuItemClick}
        />
      </>
    );
  }
}

export default inject("store")(observer(HideFields));
